import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { BehaviorSubject, forkJoin, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, first, map, merge, mergeMap, switchMap, takeUntil, tap } from 'rxjs/operators';
import { tags } from '../../../_shared/constants/customTags.const';
import { AppModulesType } from '../../../_shared/enums/appModulesType.enum';
import { ReservationMode } from '../../../_shared/enums/reservationMode.enum';
import { Asset, Contractor, Customer, InvoicePartner, ReservationRequest, Service, Subcontractor } from '../../../_shared/model';
import { HelperService, MfToastService, StorageService } from '../../../_shared/services';
import { ActiveModulesService } from '../../../_shared/services/activeModules.service';
import { HelperMedicalService } from '../../../_shared/services/helper-medical.service';
import { BaseState } from '../../../_shared/state/base/base.state';
import { Term } from '../../../_shared/state/treatment/treatment.actions';
import { AccountingService, CommonService } from '../../pages/home/_services';
import { CustomerFormComponent } from '../customer/customer-form/customer-form.component';
import { DATE_CONST } from './../../../_shared/constants/date-constants.const';
import { EmptySlot } from './../../../_shared/model/schedule/empty-slot.model';
import { ClearTreatmentState } from './../../../_shared/state/treatment/treatment.actions';
import { TrtWidMainPopupComponent } from './../../pages/home/treatment/trt-widgets/trt-wid-main-popup/trt-wid-main-popup.component';
import { TermFormHelperService } from './term-form.helper.service';

@Component({
    selector: 'app-term-form',
    templateUrl: './term-form.component.html',
    styleUrls: ['./term-form.component.scss'],
})
export class TermFormComponent implements OnInit {
    public searching = false;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public servicesForSubconstractor: Observable<any[]>;
    public hdApps = [
        { name: 'Halo Doktor', type: 'HDD' },
        { name: 'Zdravnik na daljavo', type: 'SAVAD' },
        { name: 'Medifit App', type: 'MDFTD' },
        { name: 'Laif App', type: 'LAIFD' },
    ];
    public assets: Asset[];
    // private loggedUser: User;
    public addTermForm: FormGroup;
    public searchFailed = false;
    public hideSearchingWhenUnsubscribed = new Observable(() => () => (this.searching = false));
    public allSubcontractors: Subcontractor[];
    public isSubmited = false;
    public showLoadingButton = false;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public minSelectionDate: any = moment().add(-1, 'd').toDate();
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public timeInputMask: any = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public customTags: any = this.helper.loadCustomTags();
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public reacurringType: any = tags.RECURRING_NEW;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public reacurringTypeTable: any = tags.RECURRING_NEW.table.filter(el => el.id != 7);
    public reservationTypes = ReservationMode;
    public isCreateReservationFromDraft = false;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public calendarOptions: any = this.helper.getDateSettngs(null);
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public calendarEmptyOptions: any = this.helper.getDateSettngsEmpty();
    public popupTitle: string;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public isInputVisible: any = {
        dateTime: true,
        recurringInput: true,
        generictitleInput: false,
        customerInput: true,
        servicesInput: true,
        servicesFixedInput: false,
        isAddCustomerButtonVisible: true,
        telemedicineInput: false,
        payer: false,
    };

    @Input()
    public resRequestData: ReservationRequest;

    @Input()
    public termType: ReservationMode = ReservationMode.RESERVE;

    @Input()
    customerForTerm: Customer;
    @Input()
    disableDateChange = false;
    @Input()
    termComment: string;
    @Input()
    customerForm: CustomerFormComponent;
    @Input()
    showGenericTermDeleteButton = false;
    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    businessHours: any;
    @Input()
    isCase = false;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onOpenCustomerEditForm = new EventEmitter<Customer>();
    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onOpenNewCustomerForm = new EventEmitter<any>();
    @Output()

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onOpenNewPayerForm = new EventEmitter<any>();
    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onClosePopup = new EventEmitter<any>();

    private onDestroy$ = new Subject<void>();

    private reloadPayers$ = new BehaviorSubject<void>(null);
    public invoicePartners$ = this.createInvoicePartners$();

    public isTelemedicineModuleActive = false;
    public isRecurringModuleActive = false;
    public isTelephonyModuleActive = false;
    public isTreatmentModuleActive = false;
    public isHDActive = false;

    constructor(
        private commonRest: CommonService,
        private storage: StorageService,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        public toastr: MfToastService,
        private helper: HelperService,
        private localHelper: TermFormHelperService,
        private modalService: NgbModal,
        private store: Store,
        public am: ActiveModulesService,
        public mta: HelperMedicalService,
        private accountingRest: AccountingService,
    ) {}

    ngOnInit() {
        this.commonRest
            .getAllAssets(this.storage.getSelectedContractor().id)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(assets => {
                this.assets = assets;
            });
        this.isTelemedicineModuleActive = this.am.isAM(AppModulesType.TELEMEDICINE);
        this.isTelephonyModuleActive = this.am.isAM(AppModulesType.TELEPHONY);
        this.isTreatmentModuleActive = this.am.isAM(AppModulesType.TREATMENTS);
        this.isRecurringModuleActive = this.am.isAM(AppModulesType.RECURRING);
        this.isHDActive = this.am.isAM(AppModulesType.HELLO_DOCTOR);
        this.validateVisibleInputs();
        if (this.resRequestData.reservationMode === ReservationMode.INTERNAL) {
            this.getAllSubcontractors();
            this.showFormForGeneric();
        } else if (this.resRequestData.reservationMode === ReservationMode.QUEUE) {
            this.getSubcontractosForSelectedService(this.resRequestData.selectedService.id)
                .pipe(
                    takeUntil(this.onDestroy$),
                    mergeMap(
                        () => this.getServiceForSubcontractor(this.resRequestData.selectedService.id),
                        (subcontractors, service) => ({ subcontractors: subcontractors, service: service }),
                    ),
                )
                .subscribe(res => {
                    this.allSubcontractors = res.subcontractors;
                    if (Array.isArray(res.service)) {
                        this.resRequestData.selectedService = res.service[0];
                        this.addTermForm.controls['services']?.setValue(res.service[0]);
                    } else {
                        this.resRequestData.selectedService = res.service;
                        this.addTermForm.controls['services']?.setValue(res.service);
                    }
                    this.isInputVisible.isAddCustomerButtonVisible = false;
                    this.setDisableFormForWaitingQueue();
                    this.calcEndTime(res.service);
                });
            this.createForm();
        } else {
            if (this.isCase) {
                this.getCertainSubcontractors();
            } else {
                this.getAllSubcontractors();
            }
            this.createForm();
        }
        if (this.resRequestData.isEditMode) {
            this.isSubmited = true;
            this.addTermForm.controls.assets?.setValidators(Validators.required);
            this.addTermForm.controls.assets?.updateValueAndValidity();
            // this.setValidityOfForm();
        }

        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.localHelper.closePopup.subscribe(res => {
            this.activeModal.dismiss();
        });
        this.localHelper.showLoading.subscribe(res => {
            this.showLoadingButton = res;
        });

        this.localHelper.result.subscribe(res => {
            this.activeModal.dismiss(res);
        });

        this.localHelper.visitResult.subscribe(res => {
            this.activeModal.dismiss(res);
        });

        this.popupTitle = this.resRequestData.popupTitle;
    }

    private getServiceForSubcontractor(serviceId: number): Observable<Service> {
        return this.commonRest.getServiceForContractor(this.storage.getSelectedContractor().id, serviceId);
    }

    private getAllSubcontractors() {
        this.commonRest
            .getAllSubcontractors(this.storage.getSelectedContractor().id)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((subcontractors: Subcontractor[]) => {
                this.allSubcontractors = subcontractors;
                //ce je urajanje se naložijo se storitve
                if (this.resRequestData.selectedSubcontractor) {
                    this.loadAllServices(this.resRequestData.selectedSubcontractor);
                }
            });
    }

    private getCertainSubcontractors() {
        let subcontractors$;
        if (this.resRequestData.event.serviceGroup) {
            subcontractors$ = this.commonRest.getSubcontractorsForGroup(
                this.storage.getSelectedContractor().id,
                this.resRequestData.event.serviceGroup.id,
            );
        } else {
            subcontractors$ = this.commonRest.getSubcontractorsDeliveringService(
                this.storage.getSelectedContractor().id,
                this.resRequestData.event.service.id,
            );
        }
        subcontractors$.pipe(takeUntil(this.onDestroy$)).subscribe((subcontractors: Subcontractor[]) => {
            this.allSubcontractors = subcontractors;

            //ce je urajanje se naložijo se storitve
            if (this.resRequestData.selectedSubcontractor) {
                this.loadAllServices(this.resRequestData.selectedSubcontractor);
            }
        });
    }

    public checkFunction(event) {
        //vzemi trenutno vrednost ŠTART in jo spremeni tudi globalno, ker funkcija calcTime to rabi da izračuna konec
        this.resRequestData.selectedTime = event.target.value;
        this.onServiceChange(false);
    }

    private getSubcontractosForSelectedService(serviceId: number): Observable<Subcontractor[]> {
        return this.commonRest.getSubcontractorsDeliveringService(this.storage.getSelectedContractor().id, serviceId);
        // .pipe(takeUntil(this.onDestroy$))
        // .subscribe((subcontractors: Subcontractor[]) => {
        //     this.allSubcontractors = subcontractors;
        // });
    }

    public openTreatment(): void {
        // ReservationRequest

        this.isSubmited = true;
        if (!this.addTermForm.valid) {
            return;
        }

        this.store.dispatch(new ClearTreatmentState());

        const rr: ReservationRequest = new ReservationRequest().deserialize(
            this.localHelper.fillRequestData(this.resRequestData, this.addTermForm.getRawValue()),
        );
        const emptySlot: EmptySlot = {
            asset: rr.selectedAsset,
            startDate: rr.selectedDate.format(DATE_CONST.format.date.view),
            startTime: rr.selectedTime,
            endTime: rr.selectedTimeEnd,
            subcontractor: rr.selectedSubcontractor,
            service: rr.selectedService,
            customer: rr.customerForTerm,
        };
        this.store
            .dispatch(new Term.AddNewTerm(emptySlot))
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
                const modalNewTerm = this.modalService.open(TrtWidMainPopupComponent, {
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
                    size: 'lg',
                });
                modalNewTerm.result.then(
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    close => {
                        this.activeModal.close();
                    },
                    newEvent => {
                        this.activeModal.dismiss(newEvent);
                    },
                );
            });

        // rr.reservationMode = ReservationMode.RESERVE;

        // const treatment: TreatmentGUI = new TreatmentGUI().deserialize({
        //     id: undefined,
        //     customer: rr.customerForTerm,
        //     description: '',
        // });
        // //TODO Term.AddNewTerm
        // this.store
        //     .dispatch([new Term.AddBaseTerm(rr), new TreatmentActions.SetTreatment(treatment)])
        //     .pipe(takeUntil(this.onDestroy$))
        //     .subscribe(() => {
        //         const modalNewTerm = this.modalService.open(TrtWidMainPopupComponent, {
        //             backdrop: 'static',
        //             keyboard: false,
        //             windowClass:
        //                 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
        //             size: 'lg',
        //         });
        //         modalNewTerm.result.then(
        //             (close) => {
        //                 this.activeModal.close();
        //             },
        //             (newEvent) => {
        //                 this.activeModal.dismiss(newEvent);
        //             },
        //         );
        //     });
    }

    public validateVisibleInputs(): void {
        if (
            this.resRequestData.isEditMode ||
            this.resRequestData.reservationMode === this.reservationTypes.QUEUE ||
            this.resRequestData.reservationMode === this.reservationTypes.DRAFT
        ) {
            this.isInputVisible.recurringInput = false;
        } else {
            this.isInputVisible.recurringInput = true;
        }

        //generictitleInput
        if (this.resRequestData.reservationMode === this.reservationTypes.INTERNAL) {
            this.isInputVisible.generictitleInput = true;
        } else {
            this.isInputVisible.generictitleInput = false;
        }

        //customerInput
        if (this.resRequestData.reservationMode !== this.reservationTypes.INTERNAL) {
            this.isInputVisible.customerInput = true;
        } else {
            this.isInputVisible.customerInput = false;
        }

        // servicesInput
        if (this.resRequestData.reservationMode !== this.reservationTypes.INTERNAL) {
            this.isInputVisible.servicesInput = true;
        } else {
            this.isInputVisible.servicesInput = false;
        }

        // telemedicineInput
        if (this.resRequestData.reservationMode !== this.reservationTypes.INTERNAL) {
            this.isInputVisible.telemedicineInput = this.isTelemedicineModuleActive || this.isTelephonyModuleActive;
        } else {
            this.isInputVisible.telemedicineInput = false;
        }

        // payer
        if (this.resRequestData.reservationMode !== this.reservationTypes.INTERNAL) {
            this.isInputVisible.payer = true;
        } else {
            this.isInputVisible.payer = false;
        }

        // servicesFixedInput
        if (
            this.resRequestData.reservationMode === this.reservationTypes.QUEUE ||
            this.resRequestData.reservationMode === this.reservationTypes.DRAFT
        ) {
            this.isInputVisible.servicesFixedInput = true;
        } else {
            this.isInputVisible.servicesFixedInput = false;
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public equalsAnyById(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return;
        }
        return o1.id === o2.id;
    }

    public formatter(x: { name: string; surname: string; address: string; post: string; city: string }) {
        if (!x.name) {
            return;
        }
        let result: string = x.name + ' ' + x.surname;
        if (x.address) {
            result += ' ' + x.address;
        }
        if (x.post) {
            result += ' ' + x.post;
        }
        if (x.city) {
            result += ' ' + x.city;
        }

        return result;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public onSubConctractorChange(subcontractor): void {
        if (subcontractor) {
            this.loadAllServices(subcontractor);
        } else {
            this.servicesForSubconstractor = undefined;
        }
    }

    public onServiceChange(resetTelemed: boolean = true): void {
        if (_.has(this.addTermForm, 'controls["services"].value')) {
            this.calcEndTime(this.addTermForm.controls['services']?.value);
            if (this.isInputVisible.telemedicineInput && resetTelemed) {
                if (this.isTelemedicineModuleActive) {
                    this.addTermForm.controls['telemed']?.setValue(_.get(this.addTermForm, "controls['services'].value.telemed"));
                }
                if (this.isTelephonyModuleActive) {
                    this.addTermForm.controls['phoneCall']?.setValue(_.get(this.addTermForm, "controls['services'].value.phoneCall"));
                }
            }
        }
    }

    private loadAllServices(subcontractor: Contractor): void {
        // glede na to kaj imaš poklukano glede bookiranja (storitve,skupine) ti naredi observable
        const contractorSettings = _.get(this.storage.getContractorSettings(), 'booking.bookingTypes', ['services']);
        const dataCall = {
            subContractorServices: contractorSettings.includes('services')
                ? this.commonRest.getServicesForSubcontractor(this.storage.getSelectedContractor().id, subcontractor?.id)
                : of([]),
            allGroups: contractorSettings.includes('groups')
                ? this.commonRest.getGroupsForSubContractor(this.storage.getSelectedContractor().id, subcontractor?.id)
                : of([]),
        };
        this.servicesForSubconstractor = forkJoin(dataCall).pipe(
            takeUntil(this.onDestroy$),
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            map((res: { subContractorServices: any[]; allGroups: any[] }) => {
                res.subContractorServices = res.subContractorServices.filter(el => !el.isCoupon);
                // poiscemo pravo storitev
                if (this.resRequestData?.selectedService) {
                    //menjava podizvajalca na obstoječi rezervaciji
                    this.resRequestData.selectedService = res.subContractorServices.find(el => el.id === this.resRequestData.selectedService.id);

                    this.addTermForm.controls['services']?.setValue(this.resRequestData.selectedService);
                } else if (this.resRequestData?.serviceGroup) {
                    this.resRequestData.serviceGroup = res.allGroups.find(el => el.id === this.resRequestData.serviceGroup.id);
                } else {
                    //menjava podizvajalca na novi rezervaciji
                    if (this.addTermForm.controls['services']) {
                        //če je storitev ob menjavi podizvajalca že izbrana -> preveri če jo ima izbran podizvajalec
                        const newSubcontractorHasPreviousSelectedService = res?.subContractorServices.find(
                            el => el?.id === this.addTermForm?.controls['services']?.value?.id,
                        );
                        if (!newSubcontractorHasPreviousSelectedService) {
                            this.addTermForm?.controls['services']?.setValue(undefined);
                            if (this.addTermForm.controls['telemed']) this.addTermForm?.controls['telemed']?.setValue(false);
                        }
                    }
                }
                //označi da je nekej skupina, nekej pa storitev za grupiranje v ng-select
                res.subContractorServices.map(service => (service.type = 'SERVICE'));
                res.allGroups.map(group => (group.type = 'GROUP'));

                let allDisplayedServices = res.allGroups.concat(res.subContractorServices);
                //find če obstaja razpoložljivost za ta čas
                const BH = this.getBusinessHours();
                if (
                    BH?.services &&
                    this.addTermForm?.value?.subcontractor?.id === this.resRequestData?.selectedSubcontractor?.id &&
                    this.resRequestData?.selectedAsset?.id === this.addTermForm?.value?.assets?.id
                ) {
                    //izbran termin s klikom na razpoložljivost -> uporabi storitve, ki so definirane v razpoložljivosti
                    allDisplayedServices = allDisplayedServices?.filter(service => BH?.services?.includes(service?.id));
                }
                return allDisplayedServices;
            }),
        );
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getBusinessHours(): any {
        const selDate = this?.addTermForm?.value?.start?.split('.');
        const selDateFormat = `${selDate[2]}-${selDate[1]}-${selDate[0]}`;
        //06.05.2021 --> 2021-05-06
        const selectedDate = moment(selDateFormat)?.set({
            hours: Number(this.addTermForm?.value?.startTime?.split(':')[0]),
            minute: Number(this.addTermForm?.value?.startTime?.split(':')[1]),
        });

        const foundBH = this.businessHours?.find(bh => {
            const startTimeBH = moment(selDateFormat).set({
                hours: Number(bh?.startTime?.split(':')[0]),
                minute: Number(bh?.startTime?.split(':')[1]),
            });
            const endTimeBH = moment(selDateFormat).set({
                hours: Number(bh?.endTime?.split(':')[0]),
                minute: Number(bh?.endTime?.split(':')[1]),
            });
            if (
                bh?.daysOfWeek?.includes(selectedDate?.isoWeekday()) &&
                moment(selectedDate)?.isAfter(startTimeBH) &&
                moment(selectedDate)?.isBefore(endTimeBH)
            ) {
                // razpoložljivost je isti dan + trenutno izbran termin je v okviru te razpoložljivosti
                return bh;
            }
        });
        return foundBH || [];
    }

    public createForm(): void {
        this.addTermForm = this.fb.group({
            customer: this.fb.control({ value: this.resRequestData.customerForTerm, disabled: false }),
            subcontractor: this.fb.control({ value: this.resRequestData.selectedSubcontractor, disabled: false }, Validators.required),
            start: this.fb.control(
                {
                    value: _.get(this.resRequestData, 'selectedDate', moment()).format('DD.MM.YYYY'),
                    disabled: this.disableDateChange,
                },
                Validators.required,
            ),
            startTime: this.fb.control(
                { value: this.resRequestData.selectedTime, disabled: this.resRequestData.disableDateChange },
                Validators.required,
            ),
            endTime: this.fb.control(
                { value: this.resRequestData.selectedTimeEnd, disabled: this.resRequestData.disableDateChange },
                Validators.required,
            ),
            services: this.fb.control({
                value: this.resRequestData.serviceGroup ? this.resRequestData.serviceGroup : this.resRequestData.selectedService,
                disabled: this.isCase,
            }),
            hdApp: this.fb.control({}),
            assets: this.fb.control({ value: this.resRequestData.selectedAsset, disabled: false }, Validators.required),
            telemed: this.fb.control({ value: this.resRequestData.telemed, disabled: false }),
            phoneCall: this.fb.control({ value: this.resRequestData.phoneCall, disabled: false }),
            smsNotify: this.fb.control({
                value: _.get(this.resRequestData, 'customerForTerm.sendSms'),
                disabled: false,
            }),
            emailNotify: this.fb.control({
                value: _.get(this.resRequestData, 'customerForTerm.sendMail'),
                disabled: false,
            }),
            comment: this.fb.control({ value: this.resRequestData.termComment, disabled: false }),
            customTag: this.fb.control({
                value: this.customTags.find(el => {
                    if (!_.isNil(this.resRequestData.customTagId)) {
                        return el.id === _.get(this.resRequestData, 'customTagId', 1);
                    }
                    return 1;
                }),
                disabled: false,
            }),
            recurring: this.fb.control({
                value: this.reacurringType.table.find(el => el.id === _.get(this.resRequestData, 'recurringType', this.reacurringType.obj.SINGLE).id),
                disabled: false,
            }),
            recurringUntil: this.fb.control({
                value: '',
                disabled:
                    _.get(this.resRequestData, 'recurringType', this.reacurringType.obj.SINGLE).id === this.reacurringType.obj.SINGLE ? false : true,
            }),
            payer: this.fb.control(null),
        });

        if (this.resRequestData?.selectedSubcontractor) {
            this.onSubConctractorChange(this.resRequestData.selectedSubcontractor);
        }

        this.addTermForm.controls['telemed']?.valueChanges.subscribe((value: boolean) => {
            if (value) {
                this.addTermForm.controls['phoneCall']?.setValue(false);
            }
        });

        this.addTermForm.controls['phoneCall']?.valueChanges.subscribe((value: boolean) => {
            if (value) {
                this.addTermForm.controls['telemed'].setValue(false);
            }
        });

        // this.allData ? this.reacurringType.find(el => el.id === 0) : this.reacurringType[0]
    }

    public showFormForGeneric(): void {
        this.addTermForm = this.fb.group({
            subcontractor: this.fb.control({ value: this.resRequestData.selectedSubcontractor, disabled: false }, Validators.required),
            start: this.fb.control(
                {
                    value: _.get(this.resRequestData, 'selectedDate', moment()).format('DD.MM.YYYY'),
                    disabled: this.disableDateChange,
                },
                Validators.required,
            ),
            startTime: this.fb.control(
                { value: this.resRequestData.selectedTime, disabled: this.resRequestData.disableDateChange },
                Validators.required,
            ),
            endTime: this.fb.control(
                { value: this.resRequestData.selectedTimeEnd, disabled: this.resRequestData.disableDateChange },
                Validators.required,
            ),
            assets: this.fb.control({ value: this.resRequestData.selectedAsset, disabled: false }),
            telemed: this.fb.control({ value: this.resRequestData.telemed, disabled: false }),
            comment: this.fb.control({ value: this.resRequestData.termComment, disabled: false }),
            generictitle: this.fb.control({ value: this.resRequestData.genericTitle, disabled: false }, Validators.required),
            customTag: this.fb.control({
                value: this.customTags.find(el => el.id === _.get(this.resRequestData, 'customTagId', 1)),
                disabled: false,
            }),
            recurring: this.fb.control({
                value: this.reacurringType.table.find(el => el.id === _.get(this.resRequestData, 'recurringType', this.reacurringType.obj.SINGLE).id),
                disabled: false,
            }),
            recurringUntil: this.fb.control({
                value: '',
                disabled:
                    _.get(this.resRequestData, 'recurringType', this.reacurringType.obj.SINGLE).id === this.reacurringType.obj.SINGLE ? false : true,
            }),
        });
        // this.setValidationsForGenericTerm();
    }

    public findSimilarCustomers(): void {
        //TODO
        this.localHelper.findSimilarCustomers(this.addTermForm, this.resRequestData).pipe(takeUntil(this.onDestroy$)).subscribe();
    }
    public openCustomerEditForm(): void {
        this.onOpenCustomerEditForm.emit(this.addTermForm.value.customer);
    }

    private calcEndTime(service: Service): void {
        if (service && this.resRequestData.selectedTime) {
            this.addTermForm.controls?.endTime?.setValue(
                moment(this.resRequestData.selectedTime, 'HH:mm').add(service.length, 'minutes').format('HH:mm'),
            );
        }
    }

    public setDate(event): void {
        this.addTermForm.controls?.start?.setValue(event.start);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public setRecurringDate(event: any): void {
        this.addTermForm.controls?.recurringUntil?.setValue(event.start.format('DD.MM.YYYY'));
    }

    public onSubmitNewTerm(): void {
        this.setValidityOfForm();
        this.createNewTerm();
    }

    private setValidityOfForm(): void {
        if (this.resRequestData.reservationMode === this.reservationTypes.INTERNAL) {
            this.setValidationsForGenericTerm();
        } else {
            this.setValidationsForTerm();
        }
    }

    public onSubmitDraftTerm(): void {
        this.setValidationsForDraftTerm();
        this.createNewTerm('draft');
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private createNewTerm(draft?: any): void {
        this.isSubmited = true;
        if (!this.addTermForm.valid) {
            return;
        }
        this.showLoadingButton = true;
        if (draft && draft === 'draft') {
            this.resRequestData.reservationMode = this.reservationTypes.DRAFT;
        }
        this.localHelper.manageTerm(this.resRequestData, this.addTermForm, this.businessHours);
    }

    private setValidationsForGenericTerm(): void {
        //customer
        if (this.addTermForm.controls.customer) {
            this.addTermForm.controls.customer?.setValidators([]);
            this.addTermForm.controls.customer?.updateValueAndValidity();
        }
        //service
        if (this.addTermForm.controls.services) {
            this.addTermForm.controls.services?.setValidators([]);
            this.addTermForm.controls.services?.updateValueAndValidity();
        }
        // //asset
        if (this.addTermForm.controls.assets) {
            this.addTermForm.controls.assets?.setValidators([]);
            this.addTermForm.controls.assets?.updateValueAndValidity();
        }
    }

    private setValidationsForDraftTerm(): void {
        //customer
        this.addTermForm.controls.customer?.setValidators(Validators.required);
        this.addTermForm.controls.customer?.updateValueAndValidity();
        //service
        this.addTermForm.controls.services?.setValidators(Validators.required);
        this.addTermForm.controls.services?.updateValueAndValidity();
        //asset
        this.addTermForm.controls.assets?.setValidators(Validators.required);
        this.addTermForm.controls.assets?.updateValueAndValidity();
    }

    private setValidationsForTerm(): void {
        //customer
        this.addTermForm.controls.customer?.setValidators([]);
        this.addTermForm.controls.customer?.updateValueAndValidity();
        //service
        if (this.resRequestData.origin === 'customer') {
            this.addTermForm.controls.services?.setValidators(Validators.required);
        } else {
            this.addTermForm.controls.services?.setValidators([]);
        }
        this.addTermForm.controls.services?.updateValueAndValidity();
        // //asset
        this.addTermForm.controls.assets?.setValidators([]);
        this.addTermForm.controls.assets?.updateValueAndValidity();
    }

    private setDisableFormForWaitingQueue(): void {
        if (this.addTermForm.controls.customer) {
            this.addTermForm.controls.customer?.disable();
        }
        if (this.addTermForm.controls.services) {
            this.addTermForm.controls.services?.disable();
        }
    }

    public search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => (this.searching = true)),
            switchMap(term =>
                this.commonRest.searchCustomers(term).pipe(
                    tap(result => {
                        if (result.length < 1) {
                            this.searchFailed = true;
                        } else {
                            this.searchFailed = false;
                        }
                    }),
                    catchError(() => {
                        return of([]);
                    }),
                ),
            ),
            tap(() => (this.searching = false)),
            merge(this.hideSearchingWhenUnsubscribed),
        );

    public openNewPatientDialog() {
        this.onOpenNewCustomerForm.emit();
    }

    public openNewPayerDialog() {
        this.onOpenNewPayerForm.emit();
    }

    public onCustomerChange(customer): void {
        if (customer) {
            this.addTermForm.controls['emailNotify']?.setValue(customer.sendMail);
            this.addTermForm.controls['smsNotify']?.setValue(customer.sendSms);
        }
    }

    public deleteTerm(): void {
        this.localHelper.deleteTerm(this.resRequestData);
    }

    public createReservationFromDraft(): void {
        this.resRequestData.isCreateReservationFromDraft = true;
        this.createNewTerm();
    }

    public createReservationFromReacurring(): void {
        this.resRequestData.isOpenReservation = true;
        // this.resRequestData.recurringId = '3'
        this.createNewTerm();
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onRecurringChange(event: any): void {
        if (event.id === this.reacurringType.obj.SINGLE.id) {
            this.addTermForm.controls.recurringUntil?.disable();
        } else {
            this.addTermForm.controls.recurringUntil?.enable();
            this.calendarEmptyOptions = this.helper.getDateSettngsEmpty(
                moment(_.get(this.addTermForm, 'controls.start.value', moment()), 'DD.MM.YYYY'),
            );
            // this.addTermForm.controls.recurringUntil.setValue(
            //     _.get(this.addTermForm, 'controls.start.value', moment().format('DD.MM.YYYY'))
            // );
        }
    }

    private createInvoicePartners$(): Observable<InvoicePartner[]> {
        return this.reloadPayers$.pipe(
            switchMap(() => this.store.select(BaseState.activeContractorId).pipe(first())),
            switchMap(constractorId => this.accountingRest.searchInvoicePartners(constractorId)),
        );
    }

    public reloadPayers(): void {
        this.reloadPayers$.next(null);
    }
}
